import { render } from "./twoCom.vue?vue&type=template&id=eb49d390&scoped=true"
import script from "./twoCom.vue?vue&type=script&lang=js"
export * from "./twoCom.vue?vue&type=script&lang=js"

import "./twoCom.vue?vue&type=style&index=0&id=eb49d390&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb49d390"]])

export default __exports__